import { createTheme } from '@mui/material/styles'

const blue = "#0096d6";
const blueDark = "#007db3";
const orange = "#ff9102";
const orangeLight = "#ffb24f"
const orangeDark = "#cc7400";
const red = "#d32f2f";
const redLight = "#ef5350";
const redDark = "#c62828";
const green = "#05aa05";
const greenLight = "#17d133";
const greenDark = "#2e7d32";
const grey = "#9f9f9f";

export const ThemeMobile = createTheme({
    typography: {
        "fontFamily": `"Roboto", sans-serif`,
        "fontSize": 16
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: "white",
                    backgroundColor: orange,
                    width: "auto",
                    boxShadow: "1px 1px 5px grey",
                    paddingLeft: "25px",
                    paddingRight: "25px",
                    borderRadius: "15px",
                    "&:disabled": {
                        color: 'white',
                        backgroundColor: grey,
                        boxShadow: "1px 1px 5px grey"
                    },
                    ":hover": {
                        backgroundColor: orangeDark,
                        boxShadow: "1px 1px 5px grey"
                    }
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: "12px"
                },
            },
        },
    },
    palette: {
        background: {
            default: blue
        },
        primary: {
            light: blue,
            main: blue,
            dark: blueDark,
            contrastText: "#ffffff"
        },
        secondary: {
            light: orangeLight,
            main: orange,
            dark: orangeDark,
            contrastText: "#ffffff"
        },
        success: {
            light: greenLight,
            main: green,
            dark: greenDark,
        },
        error: {
            light: redLight,
            main: red,
            dark: redDark,
        },
        rootContainer: {
            color: "#ffffff",
            background: blue
        },
        button: {
            primary: {
                color: "#ffffff",
                background: orange,
                backgroundHover: orangeDark
            },
            apple: {
                color: "#000000",
                background: "#ffffff",
                backgroundHover: "#eeeeee"
            },
            confirm: {
                background: green,
                backgroundHover: greenDark
            },
            cancel: {
                background: red,
                backgroundHover: redDark
            }
        },
        menu: {
            color: "#ffffff",
            background: blue
        },
        progress: {
            circular: {
                primary: blue,
                secondary: orange
            },
            linear: {
                primary: orange,
                secondary: "#ffd7a3"
            }
        },
        infoIcon: blue,
        dialog: {
            title: {
                color: "#ffffff",
                background: blue
            },
            primaryButton: {
                color: "#ffffff",
                background: orange,
                backgroundHover: orangeDark,
                backgroundDisabled: grey
            }
        },
        appBar: {
            color: "#ffffff",
            background: blue
        },
        textLink: blue,
        card: {
            primary: {
                color: "#ffffff",
                background: blue
            },
            secondary: {
                color: "#ffffff",
                background: orange
            }
        }
    }
});